import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import SendingModalWrapper from '../sendingModalWrapper/SendingModalWrapper';
import {TState} from '../../../../redux/store.type';
import * as css from '../sendingModalWrapper/SendingModalWrapper.css';
import {getStaticImage} from '../../../../globalVariables/GlobalVariables';
import {approved} from '../../icons/images';
import {TShow} from '../../../prompotionPopup/PromotionPopup';

function PackageSuccessModal({show}: {show: TShow;}) {
    const {t} = useTranslation('mailing');
    const packageId = useSelector((state: TState) => state.account.mailingPackage?.mpid);
    const mailingPackageList = useSelector((state: TState) => state.account.mailingPackageList);
    const packageName = mailingPackageList?.find((mailingPackage: any) => mailingPackage.mpid === parseInt(packageId))?.name;
    const image = getStaticImage(approved);
    const buttons = {
        blueBtn: {
            text: 'close',
            onClick: show.close
        }
    };

    return (
        <SendingModalWrapper
            show={show}
            title={t('mailingBank')}
            buttons={buttons}
            dataCy="packageSuccessModal"
            headerImage={image}
            headerHeight="tall"
        >
            <css.title>{t('successTitle')}</css.title>
            <css.messageLine>{t('successMessage', {packageName: t(packageName)})}</css.messageLine>
        </SendingModalWrapper>
    );
}

export default PackageSuccessModal;
